module.exports = __webpack_public_path__ + "img/mainPage.dbb34021.svg";